export function checkValidId(id) {
  const matches = id.match(/\/|\.|\[|\]|\*|´|#/g);
  return matches === null
    ? true
    : { msgCode: '213', msg: 'None of the following characters is allowed: / . [ ] * # (%s)', args: [id] };
}
